import { render, staticRenderFns } from "./ExtensionPanels.vue?vue&type=template&id=3d91a759&scoped=true&"
import script from "./ExtensionPanels.vue?vue&type=script&lang=js&"
export * from "./ExtensionPanels.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionPanels.vue?vue&type=style&index=0&id=3d91a759&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d91a759",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VBtn,VExpansionPanel,VExpansionPanels})
